// eslint-disable-next-line import/no-unresolved
module.exports = require('./dist/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-with-styles-interface-css/index.js
// module id = 652
// module chunks = 0